import styled from '@emotion/styled';

export const ImageContainer = styled.div<{ bgColor?: string }>`
  ${p => (p.bgColor ? `background-color: ${p.bgColor};` : '')}
  height: 100%;
  width: 100%;
  min-width: 100%;
  overflow: hidden !important;
  position: relative;
`;
